import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "priceField", "onlineOrderingField", "sizesField"]

  connect() {
    this.updateFieldVisibility()
  }

  toggle() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    const enabled = this.toggleTarget.checked
    const priceInput = this.priceFieldTarget.querySelector("input")
    const ooCheckbox = this.onlineOrderingFieldTarget.querySelector("input[type=checkbox]")
    const sizePriceInputs = this.sizesFieldTarget.querySelectorAll(".size-fields input[name*='[amount]']")

    priceInput.disabled = enabled
    this.priceFieldTarget.style.opacity = enabled ? "0.4" : "1"

    sizePriceInputs.forEach(input => {
      input.disabled = enabled
    })
    this.sizesFieldTarget.style.opacity = enabled ? "0.4" : "1"

    if (enabled) {
      ooCheckbox.checked = false
      ooCheckbox.disabled = true
    } else {
      ooCheckbox.disabled = false
    }
  }
}
